/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import pRetry from 'p-retry';

import Loading from './Loading';
import Main from './Main';

const useStyles = makeStyles((theme) => ({
  app: {
    backgroundColor: theme.palette.background.main,
    padding: '40px 0 0 0',
  },
  contentWrapper: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  intro: {
    fontSize: '1.125em',
  },
  introText: {
    maxWidth: 700,
  },
  cta: {
    backgroundColor: '#BE7999',
    padding: '10px 15px',
    borderRadius: 3,
    width: '100%',
    maxWidth: 270,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#955e78',
    },
  },
  ctaText: {
    display: 'block',
    fontSize: '0.7em',
    paddingTop: 10,
    maxWidth: 270,
  },
  gridItmBubble: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  gridItmTopJournalists: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
    '@media (min-width: 1100px)': {
      paddingLeft: '102px !important',
    },
  },

}));

const App = () => {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [error, setError] = useState(null);

  const classes = useStyles();

  // const handleLoggedInChange = (loggedIn) => {
  //   setIsLoggedIn(loggedIn);
  // };

  // const fetchLogin = () => {
  //   fetch('https://qdt.qlik.com/login', {
  //     method: 'POST',
  //     credentials: 'include',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.success) {
  //         handleLoggedInChange(true);
  //       }
  //     })
  //     .catch(() => {
  //       // handleLoggedInChange(false);
  //     });
  // };
  // const fetchLogin = async () => {
  //   const response = await fetch('https://qdt.qlik.com/login', {
  //     method: 'POST',
  //     credentials: 'include',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   });
  //   const data = await response.json();

  //   if (!data.success) {
  //     throw new Error(`Fetch failed with status: ${response.status}`);
  //   }

  //   setIsLoggedIn(true);
  // };

  // useEffect(async () => {
  //   if (isLoggedIn || error) return;
  //   const fetchWithRetry = async () => {
  //     try {
  //       await pRetry(fetchLogin, {
  //         onFailedAttempt: (err) => {
  //           console.log(`Attempt ${err.attemptNumber} failed. There are ${err.retriesLeft} retries left.`);
  //         },
  //         retries: 5,
  //       });
  //     } catch (finalError) {
  //       setError('Something went wrong. Please try again later.');
  //     }
  //   };

  //   fetchWithRetry();
  // }, [isLoggedIn, error]);

  // if (error) {
  //   return (
  //     <div style={{
  //       width: '100%',
  //       height: '100vh',
  //       display: 'flex',
  //       flexDirection: 'column',
  //       alignContent: 'center',
  //       justifyContent: 'center',
  //       textAlign: 'center',
  //     }}
  //     >
  //       <div>
  //         {error}
  //       </div>
  //     </div>
  //   );
  // }

  return (

  // isLoggedIn ? (
  //   <div className={classes.app}>
  //     <Main handleLoggedInChange={handleLoggedInChange} />
  //   </div>
  // ) : <Loading />

    <div className={classes.app}>
      <Main />
    </div>

  );
};

App.propTypes = {};

export default App;
